<template>
  <div class="athena-register">
    <div class="container tiny">
      <div class="create">
        <h2>{{ $t("login.create_account") }}</h2>
        <ul class="error">
          <li v-html="error_first_name"></li>
          <li v-html="error_last_name"></li>
          <li v-html="error_email"></li>
          <li v-html="error_password"></li>
        </ul>
        <form method="POST" action="/register">
          <input type="hidden" name="_token" :value="token" />
          <div class="row">
            <div class="col-12">
              <label
                for="first_name"
                class="col-form-label col-12"
                style="padding-left: 0px"
                >{{ $t("login.first_name") }}</label
              >
              <input
                v-model="name"
                id="name"
                type="text"
                class="form-control"
                :class="name_style"
                @click="name_style = 'active_focus'"
                @blur="name_style = ''"
                name="first_name"
                autocomplete="name"
                autofocus
              />
            </div>
            <div class="col-12">
              <label
                for="last_name"
                class="col-form-label col-12"
                style="padding-left: 0px"
                >{{ $t("login.last_name") }}</label
              >
              <input
                v-model="last_name"
                id="last_name"
                type="text"
                class="form-control"
                :class="last_name_style"
                @click="last_name_style = 'active_focus'"
                @blur="last_name_style = ''"
                name="last_name"
                autocomplete="name"
              />
            </div>
            <div class="col-12 col-md-6"></div>
          </div>
          <div class="row">
            <label for="email" class="col-form-label col-12">{{
              $t("login.email")
            }}</label>
            <div class="col-12">
              <input
                v-model="email"
                type="email"
                class="form-control"
                :class="email_style"
                @click="email_style = 'active_focus'"
                @blur="email_style = ''"
                name="email"
                required
                autocomplete="email"
                autofocus
              />
            </div>
          </div>
          <div class="row">
            <label for="password" class="col-form-label col-12">{{
              $t("login.password")
            }}</label>
            <div class="col-12">
              <input
                v-model="password"
                id="password"
                type="password"
                class="form-control"
                :class="password_style"
                name="password"
                required
                autocomplete="new-password"
                @blur="password_style = ''"
                @click="password_style = 'active_focus'"
              />
            </div>
            <div style="height: 50px" class="col-12">
              <label>
                <input
                  class="register-checkbox"
                  type="checkbox"
                  v-model="subscribed"
                />
                <span class="register-subscribe">
                  {{ $t('account.subscribe_us') }}?
                </span>
              </label>
              <!-- <span class="register-subscribe"
                >SUBSCRIBE TO OUR NEWSLETTER?</span
              > -->
            </div>
          </div>
          <div class="row" style="display: none">
            <label for="password_confirmation" class="col-form-label col-12"
              >password_confirmation</label
            >
            <div class="col-12">
              <input
                v-model="password"
                id="password-confirm"
                type="password"
                class="form-control"
                name="password_confirmation"
              />
            </div>
          </div>
          <div class="return-xl">
            <a
              style="padding: 0; margin: 18px 0; text-transform: capitalize;"
              class="col-12"
              href="/account/login"
            >
              {{ $t('account.returning_customer') }}? {{ $t('login.login') }} >
            </a>
          </div>
          <div style="margin-top: 6px; display: flex;">
            <button
              @click="save"
              type="submit"
              class="col-12 col-md-auto"
              id="loginbtn"
              style="white-space: nowrap, padding: 9px 15px"
            >
              <span>{{ $t("login.create") }}</span>
            </button>
            <v-social-auth v-if="social_auth" :social_auth="social_auth" class="col-12 col-md-7 text-md-right text-center" style="display:inline-block;margin: 0 0 0 auto;"></v-social-auth>
          </div>
          <div class="row return-md">
            <a
              style="padding: 0; margin: 18px 0; text-transform: capitalize;"
              class="col-12"
              href="/account/login"
            >
              {{ $t('account.returning_customer') }}? {{ $t('login.login') }} >
            </a>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import vSocialAuth  from "@/js/components/view/socialauth/index.vue"
export default {
  props: [
    "error_last_name",
    "error_first_name",
    "error_password",
    "error_email",
    "social_auth",
  ],
  data() {
    return {
      token: document.head.querySelector('meta[name="csrf-token"]').content,
      password: "",
      email: "",
      name: "",
      last_name: "",
      name_style: "",
      email_style: "",
      last_name_style: "",
      password_style: "",
      subscribed: false,
    };
  },
  methods: {
    save() {
      window.sessionStorage.setItem("name", this.name);
      window.sessionStorage.setItem("last_name", this.last_name);
      window.sessionStorage.setItem("email", this.email);
      if(window.snaptr){
        window.snaptr('track', 'SIGN_UP', {'sign_up_method':'e-mail'})
      }
    },
  },
  beforeMount() {
    if (this.error_first_name) {
      this.name_style = "active_error";
    } else if (this.error_last_name) {
      this.last_name_style = "active_error";
    } else if (this.error_email) {
      this.email_style = "active_error";
    } else if (this.error_password) {
      this.password_style = "active_error";
    }
    if (
      this.error_first_name ||
      this.error_last_name ||
      this.error_email ||
      this.error_password
    ) {
      this.email = window.sessionStorage.getItem("email");
      this.last_name = window.sessionStorage.getItem("last_name");
      this.name = window.sessionStorage.getItem("name");
    }
  },
  components:{
    vSocialAuth
  }
};
</script>

<style  scoped lang='scss'>
.athena-register {
  margin: 100px 0 42px;
  .container {
    max-width: 520px;
    font-family: Roboto-Regular;
    color: #222a40;
    .error {
      color: red;
      font-size: 14px;
      text-align: center;
      list-style-type: none;
    }

    h2 {
      text-align: center;
      font-weight: bold;
      margin-bottom: 40px;
    }

    a {
      display: inline-block;
      font-size: 16px;
    }

    span {
      display: inline-block;
      font-size: 13px;
      text-align: center;
    }

    p {
      margin-bottom: 15px;
      line-height: 30px;
      a {
        font-size: 15px;
      }
    }

    label {
      font-size: 24px;
    }
    input {
      border-radius: 0px;
      height: 48px;
      line-height: 22px;
      padding: 12px;
      color: #1e0909;
      vertical-align: middle;
      border: 1px solid #e4e4e4;
      width: 100%;
      margin-bottom: 12px;
      cursor: pointer;
    }
    .active_error {
      border: 2px solid red;
      border-radius: 4px;
    }
    .active_focus {
      border: 2px solid #000;
      border-radius: 4px;
    }
    input:focus {
      outline: none;
      box-shadow: none;
    }
    .register-subscribe {
      font-size: 18px;
      vertical-align: middle;
      text-transform: uppercase;
    }
    .register-checkbox {
      width: 24px;
      margin: 0px;
    }
    .return-md {
      display: none;
      a {
        text-align: center;
      }
    }
    #loginbtn {
      background-color: #222a40;
      height: 52px;
      span {
        font-size: 24px;
        font-weight: 500;
        color: #fff;
      }
    }
  }
}
@media (max-width: 768px) {
  .athena-register {
    margin: 39px 0 42px;
    .container {
      max-width: 520px;
      font-family: Roboto-Regular;
      color: #222a40;
      padding: 0 15px;
      .error {
        color: red;
        font-size: 14px;
        text-align: center;
        list-style-type: none;
      }

      h2 {
        text-align: center;
        font-weight: bold;
        margin-bottom: 17px;
        font-size: 18px;
      }

      a {
        display: inline-block;
        font-size: 16px;
      }

      span {
        display: inline-block;
        font-size: 13px;
        text-align: center;
      }

      p {
        margin-bottom: 15px;
        line-height: 30px;
        a {
          font-size: 15px;
        }
      }

      label {
        font-size: 14px;
      }
      input {
        border-radius: 0px;
        height: 40px;
        line-height: 22px;
        padding: 12px;
        color: #1e0909;
        vertical-align: middle;
        border: 1px solid #e4e4e4;
        width: 100%;
        margin-bottom: 12px;
        cursor: pointer;
      }
      #password {
        margin-bottom: 0 !important;
      }
      .active_error {
        border: 2px solid red;
        border-radius: 4px;
      }
      .active_focus {
        border: 2px solid #000;
        border-radius: 4px;
      }
      input:focus {
        outline: none;
        box-shadow: none;
      }
      .register-subscribe {
        font-size: 13px;
      }
      .register-checkbox {
        width: 13px;
        margin: 0px;
      }
      .return-md {
        display: none;
        a {
          text-align: center;
          font-size: 13px;
          line-height: 21px;
        }
      }
      #loginbtn {
        background-color: #222a40;
        height: 40px;
        margin-top: 0;
        span {
          font-size: 15px;
          font-weight: 500;
          color: #fff;
        }
      }
    }
  }
  .return-xl {
    display: none !important;
  }
  .return-md {
    display: flex !important;
  }
}
</style>